import {LOAD_THEME} from './types';

export function loadTheme()
{
	return {
		type:LOAD_THEME
	};
}